import { render, staticRenderFns } from "./BranchesDropdown.vue?vue&type=template&id=5791c739&"
import script from "./BranchesDropdown.vue?vue&type=script&lang=js&"
export * from "./BranchesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BranchesDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports